import { Checkbox, CheckboxProps } from "@src/components/ui-components/Checkbox/Checkbox";
import { FieldValues, UseControllerProps, useController } from "react-hook-form";

export type ControlledCheckboxProps<TFieldValues extends FieldValues = FieldValues> = Omit<CheckboxProps, "onChange" | "value"> &
  UseControllerProps<TFieldValues>;

export const ControlledCheckbox = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  shouldUnregister,
  defaultValue,

  ...inputProps
}: ControlledCheckboxProps<TFieldValues>) => {
  const { field } = useController({
    name,
    control,
    shouldUnregister,
    defaultValue,
  });

  return <Checkbox {...field} {...inputProps} />;
};

